import React, { ChangeEvent, Component } from 'react';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../../../custom/FormicaSearchSelectBox';
import RoleHelper from '../../../../../RoleHelper';
import ComponentName from '../../../../../constant/ComponentName';
import CustomMultiSelect from '../../../../custom/CustomMultiSelect';
import { MultiSelectChangeParams } from 'primereact/multiselect';
import FormicaInput from '../../../../custom/FormicaInput';
import { FormicaProps, RouteProps, withFormica } from '../../../../../helpers/withFormica';
import { RootState } from '../../../../../redux/store';
import { ConfigurationState } from '../../../../../redux/reducers/ConfigurationReducer';
import { changeConfiguration } from '../../../../../redux/actions/ConfigurationActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import DataType from '../../../../../constant/DataType';
import { AnimatedButton } from '@trlogic/ui-pack';
import CustomTable from '../../../../custom/CustomTable';
import EmptyComponent from '../../../../custom/empty-components/EmptyComponent';
import { CaseSettings, Entity } from '../../../../../domain/case/CaseDomains';
import { ColumnProps } from 'primereact/column';
import CustomTableContentWrapper from '../../../../custom/CustomTableContentWrapper';
import Icon from '../../../../../icons/Icon';
import MessageUtil from '../../../../../util/MessageUtil';
import { isStringValid } from '../../../../../util/Generator';
import { customConfirm } from '../../../../custom/CustomPopupConfirm';
import CustomInput from '../../../../custom/CustomInput';
import LanguageUtil from '../../../../../util/LanguageUtil';

class DomainConfigurationEntityComponent extends Component<Props, State> {
  public state: State = new State();

  public render() {
    const {
      configuration: { configuration },
    } = this.props;
    const { entity } = this.state;
    const disabled = this.isDisabled();

    return (
      <div className={'flex flex-col w-full py-5 gap-y-3 px-5 gap-x-3'}>
        <div className={'flex gap-x-3 w-full items-center'}>
          <div className={'flex w-full gap-x-3'}>
            <FormicaInput
              className={'h-[34px]'}
              disabled={!RoleHelper.canEdit('CaseConfiguration')}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.name', defaultMessage: 'Name' })}
              value={entity?.name}
              onChange={this.onChangeName}
            />
            <FormicaInput
              className={'h-[34px]'}
              disabled={!RoleHelper.canEdit('CaseConfiguration')}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.description', defaultMessage: 'Description' })}
              value={entity?.description}
              onChange={this.onChangeDescription}
            />
            <FormicaSearchSelectBox
              options={this.getTransactionKeyOptions()}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.key', defaultMessage: 'Key' })}
              value={entity?.key}
              className={'w-2/6 h-[34px]'}
              rounded
              showClear
              disabled={!RoleHelper.canEdit('CaseConfiguration')}
              onChange={this.onSelectKey}
            />
            <CustomMultiSelect
              items={this.getTransactionVariableOptions()}
              maxSelectedLabels={3}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.variables', defaultMessage: 'Variables' })}
              selectedItems={entity?.variables || []}
              label={'Variables'}
              disabled={!RoleHelper.canEdit('CaseConfiguration')}
              onChange={(e: MultiSelectChangeParams) => this.onSelectVariables(e)}
            />
          </div>
          <div className={'flex '}>
            <AnimatedButton
              onClick={this.addEntityField}
              className={'w-full'}
              customSize={'sm'}
              icon={'add'}
              text={LanguageUtil.get({ id: 'common.button.add', defaultMessage: 'Add' })}
              customType={'primary'}
              disabled={disabled}
            />
          </div>
        </div>
        {configuration.entities != undefined && configuration.entities.length != 0 ? (
          <CustomTable columns={this.getColumns()} value={configuration.entities} />
        ) : (
          <EmptyComponent type={ComponentName.CONFIGURATION} />
        )}
      </div>
    );
  }

  private onChangeName = (event: ChangeEvent<HTMLInputElement>) => {
    const { entity } = this.state;
    if (this.isDisabled()) return;
    if (isStringValid(event.target.value)) {
      entity.name = event.target.value;
      this.setState({ entity });
    } else {
      MessageUtil.warning({
        summary: LanguageUtil.get({ id: 'pages.configuration.entity.summary', defaultMessage: 'Entity name can not include special characters' }),
      });
    }
  };

  private onChangeDescription = (event: ChangeEvent<HTMLInputElement>) => {
    const { entity } = this.state;
    if (this.isDisabled()) return;
    entity.description = event.target.value;
    this.setState({ entity });
  };

  private onSelectKey = (e: FormicaSelectBoxItem | undefined) => {
    const { entity } = this.state;
    if (this.isDisabled()) return;
    entity.key = e?.value;
    this.setState({ entity });
  };

  private onSelectVariables = (e: MultiSelectChangeParams) => {
    const { entity } = this.state;
    if (e.value) {
      entity.variables = e?.value;
      this.setState({ entity });
    }
  };

  private getTransactionKeyOptions = () => {
    const {
      configuration: { eventItems, configuration },
    } = this.props;
    if (configuration.dataSource == undefined) return [];
    const items = eventItems
      .find((event) => event.name == configuration.dataSource)
      ?.variables.filter((v) => v.properties.dataType == DataType.STRING)
      .map((value) => ({
        label: value.description && value.description.length > 0 ? value.description : value.name,
        value: value.name,
      }));
    return items || [];
  };

  private getTransactionVariableOptions = () => {
    const {
      configuration: { eventItems, configuration },
    } = this.props;
    if (configuration.dataSource == undefined) return [];
    const items = eventItems
      .find((event) => event.name == configuration.dataSource)
      ?.variables.map((value) => ({
        label: value.description && value.description.length > 0 ? value.description : value.name,
        value: value.name,
      }));
    return items || [];
  };

  private addEntityField = () => {
    const {
      configuration: { configuration },
      changeConfiguration,
    } = this.props;
    const { entity } = this.state;
    if (this.isDisabled()) return;
    if (entity.name == undefined || entity.key == undefined || entity.variables == undefined || entity.variables.length == 0) return;
    if (this.entityExist()) return;
    if (configuration.entities == undefined) {
      configuration.entities = [];
    }
    configuration.entities.push(entity);
    changeConfiguration(configuration);
    const newEntityField: Entity = {
      name: '',
      description: '',
      key: '',
      variables: [],
    };
    this.setState({ entity: newEntityField });
  };

  private removeEntityField = (index: number) => {
    const {
      configuration: { configuration },
      changeConfiguration,
    } = this.props;
    if (this.isDisabled()) return;
    configuration.entities.splice(index, 1);
    changeConfiguration(configuration);
  };

  private getColumns = (): ColumnProps[] => {
    const disabled = this.isDisabled();
    return [
      {
        field: 'name',
        header: LanguageUtil.get({ id: 'pages.configuration.entity.table.name', defaultMessage: 'Name' }),
        alignHeader: 'left',
        body: (record: Entity) => {
          return (
            <div className={'flex items-start text-xs 2xl:text-md'}>
              <CustomTableContentWrapper text={record.name} clipSize={30} showEllipsis={true} />
            </div>
          );
        },
      },
      {
        field: 'description',
        header: LanguageUtil.get({ id: 'pages.configuration.entity.table.description', defaultMessage: 'Description' }),
        body: (record: Entity) => {
          return <CustomInput inputType={'ghost'} onChange={(e) => this.onChangeUpdateDescription(e, record)} value={record.description} />;
        },
      },
      {
        field: 'key',
        header: LanguageUtil.get({ id: 'pages.configuration.entity.table.key', defaultMessage: 'Key' }),
        className: 'w-1/3',
        body: (record: Entity) => {
          return (
            <div className={'text-xs 2xl:text-md'}>
              <CustomTableContentWrapper text={record.key} />
            </div>
          );
        },
      },
      {
        field: 'variables',
        header: LanguageUtil.get({ id: 'pages.configuration.entity.table.key', defaultMessage: 'Key' }),
        body: (record: Entity) => {
          return (
            <CustomMultiSelect
              items={this.getTransactionVariableOptions()}
              maxSelectedLabels={3}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.variables', defaultMessage: 'Variables' })}
              selectedItems={record.variables}
              label={LanguageUtil.get({ id: 'common.label.variables', defaultMessage: 'Variables' })}
              onChange={(e: MultiSelectChangeParams) => this.onSelectUpdateVariables(e, record)}
            />
          );
        },
      },
      {
        field: 'action',
        header: LanguageUtil.get({ id: 'pages.configuration.entity.table.action', defaultMessage: 'Action' }),
        className: 'max-w-[75px] 2xl:max-w-[100px]',
        body: (record: Entity) => {
          const {
            configuration: { configuration },
          } = this.props;
          const index = configuration.entities.findIndex((entity) => entity.name === record.name);
          return (
            <div
              className={'flex w-full h-full items-center justify-center'}
              onClick={(e: any) => {
                e.stopPropagation();
                e.preventDefault();
                !disabled &&
                  customConfirm({
                    target: e.currentTarget,
                    accept: () => this.removeEntityField(index),
                    message: LanguageUtil.get({ id: 'messages.confirm.removeVariable', defaultMessage: 'Are you sure remove this variable?' }),
                  });
              }}
            >
              <Icon
                icon={'delete'}
                size={20}
                color={'primary'}
                className={`hover:text-primary text-[#607080] ${disabled ? 'cursor-not-allowed' : 'hover:cursor-pointer'} flex items-center justify-center`}
              />
            </div>
          );
        },
      },
    ];
  };

  private onChangeUpdateDescription = (event: React.FormEvent<HTMLInputElement>, record: Entity) => {
    const {
      configuration: { configuration },
      changeConfiguration,
    } = this.props;
    if (this.isDisabled()) return;
    const index = configuration.entities.findIndex((f) => f.name == record.name);
    if (index == -1) return;
    configuration.entities[index].description = event.currentTarget.value;
    changeConfiguration(configuration);
  };

  private onSelectUpdateVariables = (e: MultiSelectChangeParams, record: Entity) => {
    const {
      configuration: { configuration },
      changeConfiguration,
    } = this.props;
    if (this.isDisabled()) return;
    const index = configuration.entities.findIndex((f) => f.name == record.name);
    if (index == -1) return;
    if (e.value) {
      configuration.entities[index].variables = e.value;
      changeConfiguration(configuration);
    }
  };

  private isDisabled = () => {
    return !RoleHelper.canEdit('CaseConfiguration');
  };

  private entityExist = () => {
    const { domains } = this.props;
    const { entity } = this.state;
    if (domains != undefined && domains.length > 0) {
      const result = domains.find((domain: CaseSettings) => domain?.entities?.some((e: Entity) => e?.name === entity.name));
      if (result != undefined) {
        MessageUtil.info({
          content: `${entity.name} already exist. Change the name.`,
        });
        return true;
      }
    }
  };
}

interface Props extends RouteProps, FormicaProps, ReduxProps {
  domains: CaseSettings[];
}

const mapStateToProps = (state: RootState) => ({
  configuration: state.configuration as ConfigurationState,
  filter: state.page.filter,
});
const mapDispatchToProps = {
  changeConfiguration,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

class State {
  entity: Entity = {
    name: '',
    description: '',
    key: '',
    variables: [],
  };
  loading: boolean = true;
}

export default withFormica(connector(DomainConfigurationEntityComponent));
